import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  INVITATION_STATUS as invStatus,
} from 'shared/constants';
import PropTypes from 'prop-types';

const DashboardInvitationCard = (props) => {
  const { t } = useTranslation();
  const { name, date, id, updateStatus, invitationType } = props;
  return (
    <div key={id} className="dash-section border-bottom-gray col">
      <div className="dashboard-invitation">
        <h5>{t('dashboard.staffInvitation')}</h5>
        <p>{t('dashboard.invitationMessage')}</p>
        <p className="mb-0 text-strong">{name}</p>
        {date && <p className="mb-0 text-strong">{date}</p>}
        <div className="buttons-container pb-0 pt-2 w-100">
          <button
            className="btn btn-primary w-50"
            onClick={() => updateStatus(id, invStatus.accept, invitationType)}
          >
            {t('common.labels.accept')}
          </button>
          <button
            onClick={() => updateStatus(id, invStatus.decline, invitationType)}
            className="btn btn-outline w-50"
          >
            {t('common.labels.decline')}
          </button>
        </div>
      </div>
    </div>);
};

export default DashboardInvitationCard

DashboardInvitationCard.propTypes = {
  name: PropTypes.string,
  date: PropTypes.string,
  id: PropTypes.number,
  updateStatus: PropTypes.func,
  invitationType: PropTypes.string,
};

DashboardInvitationCard.defaultProps = {
  name: '',
  date: '',
  id: null,
  updateStatus: '',
  invitationType: '',
};
